export const MOBILE_SPLASH_EXPIRATION = 1000 * 60 * 60 * 24 * 90;
